import { render, staticRenderFns } from "./USStatesSelector.vue?vue&type=template&id=06231d52"
import script from "./USStatesSelector.vue?vue&type=script&lang=js"
export * from "./USStatesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports